"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LoadingIconSmall_1 = require("./LoadingIconSmall");
const LoadingIconLarge_1 = require("./LoadingIconLarge");
const LoadingIcon = ({ variant, version }) => {
    if (variant === 'small')
        return (0, jsx_runtime_1.jsx)(LoadingIconSmall_1.LoadingIconSmall, { version: version });
    else
        return (0, jsx_runtime_1.jsx)(LoadingIconLarge_1.LoadingIconLarge, {});
};
exports.LoadingIcon = LoadingIcon;
